import auth from "./auth"
import sync from "./sync"
import system from "./system"
import cipher from "./cipher"
import folder from "./folder"
import share from "./share"
import collection from "./collection"
import organization from "./organization"
import enterprise from "./enterprise"
import service from "./service"
import notice from "./notice"

export default {
  auth,
  sync,
  system,
  cipher,
  folder,
  share,
  collection,
  organization,
  enterprise,
  service,
  notice
}
